export default __webpack_public_path__ + "static/media/1000_in_the_fog.ad240e76.jpg";